import setCurrentPage from "src/Utils/setCurrentPage";

const LIST_DATA_BENEFITS_TEMPLATE = [
  {
    icon: "arrowsDown",
    iconColor: "white",
    text: "70% reduction in design \ncompletion cycle",
    listItemCustomStyle: { width: "288px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "computerWithRocket",
    iconColor: "white",
    text: "Optimized designer \nproductivity",
    listItemCustomStyle: { width: "244px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "gearInsidePerson",
    iconColor: "white",
    text: "Auto generation of network \ndesigns using Gen AI",
    listItemCustomStyle: { width: "auto" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

export const DATA_BENEFITS_INLCM_2 = {
  title: "AI-Powered Design Interface",
  titleNumber: "2.",
  text: "Interactive interface to visualize designs and make necessary \nmodifications. Auto design creation using AI/ML and multi-layer GIS \nfeatures for better visualization and optimized construction/builds.",
  listData: LIST_DATA_BENEFITS_TEMPLATE,
  next: {
    label: "Next Lifecycle Stage",
    onClick: () => setCurrentPage("ENG_304"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_302"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/INLCM/INLCM_INTRO_03.jpg",
};
